import { Link } from "react-router-dom";
import styles from "./AppSidebar.module.scss";
import OnlineIcon from "../../assets/icons/Logo.svg?react";
import classNames from "classnames";
import { useState } from "react";
import { animated, useSpring } from "@react-spring/web";
import AppNavigation from "./AppNavigation";

const AppSidebar = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const animation = useSpring({
    from: {
      width: "8rem",
      height: "100%"
    },
    to: {
      width: isExpanded ? "24rem" : "8rem",
      height: "100%"
    }
  });

  const expandSideBar = () => {
    setIsExpanded(!isExpanded);
  }

  return (
    <animated.div style={animation}>
      <div className={classNames(styles.appSidebar, { [styles.expandedAppSideBar]: isExpanded })}>
        <div className={classNames(styles.logoContainer, { [styles.expandedLogoContainer]: isExpanded })}>
          <Link
            key="home-link"
            to="/"
          >
            {isExpanded ? (
              <img
                src="/TherapeuticGuidelines_Original_R_Logo.svg"
                alt="Therapeutic Guidelines"
                className={styles.expandedLogo}
                data-testid="expanded-logo"
              />
            ) : (
              <OnlineIcon className={styles.logo} data-testid="small-logo"></OnlineIcon>
            )}
          </Link>
          <button onClick={expandSideBar} className={classNames("size-12", styles.menuButton)} data-testid="expand-button">
            <i className={isExpanded ? "tg-icons-MenuOpen" : "tg-icons-Menu"}></i>
          </button>
        </div>
        <AppNavigation 
          styles={styles} 
          isExpanded={isExpanded}
          variant="desktop"
        />
      </div>
    </animated.div>
  );
};

export default AppSidebar;
